import { Global } from '@emotion/react';
import React, { createContext, ReactNode, useContext } from 'react';
import { V5Styles } from './GlobalCss/V5Styles';
import { PlatformStyles } from './GlobalCss/PlatformStyles';

type ThemeContextType = {
  isRebrand?: boolean;
  isPlatform?: boolean;
};

const ThemeContext = createContext<ThemeContextType>({
  isRebrand: false,
  isPlatform: false,
});

export const useTheme = () => {
  const { isRebrand, isPlatform } = useContext(ThemeContext);
  return { isRebrand, isPlatform };
};

// 🍪 value for the rebrand
export const REBRAND_COOKIE = '__tnp';
export const PLATFORM_COOKIE = '__tzp';

export const GlobalStylesProvider = ({
  children,
  isPlatform,
  isRebrand,
}: {
  children: ReactNode;
  isPlatform?: boolean;
  isRebrand?: boolean;
}) => {
  return (
    <ThemeContext.Provider value={{ isRebrand, isPlatform }}>
      <Global styles={isPlatform ? PlatformStyles : V5Styles} />
      {children}
    </ThemeContext.Provider>
  );
};
